import React from 'react';
import ServicePlan from '../components/ServicePlan';
import Tab1 from '../assets/溫情加值服務.png';
import { useNavigate } from 'react-router-dom';
import Notice from '../assets/demand-form-info.png';
import DemandForm from './DemandForm';

const Combo: React.FC = () => {
  const navigate = useNavigate();

  // breadcrumb navigation
  const BreadcrumbNav = () => (
    <div className="flex flex-col space-y-2">
      <div className="flex items-center">
        <span
          className="text-[20px] cursor-pointer hover:text-blue-600"
          onClick={() => navigate('/')}
        >
          返回
        </span>
        <span className="mx-2 text-[20px]">/</span>
        <span className="text-[20px]">服務方案</span>
      </div>
    </div>
  );

  return (
    <>
      <div className='flex flex-col gap-4'>
        <BreadcrumbNav />
        <ServicePlan />
        <img src={Tab1} alt="溫情加值" className="w-full" />
      </div>
      <div className="relative mx-auto px-2 md:px-6 py-[50px] flex flex-col gap-4 bg-[#F6F4EF]">
        <DemandForm />
        <img src={Notice} alt="溫馨提醒" className="w-full h-[150px] md:h-fit object-cover" />
      </div>
    </>
  );
};

export default Combo;
